import { useContext, useEffect, useState } from "react";
import Data from "./Data";
import { Table } from "react-bootstrap";
import TableUI from "./Table";
import { AppContext } from "../AppContext";
import { formatNumer } from "../Web3/Function";
import Countdown from "react-countdown";
import TopHeading from "./TopHeading";
import { coinGeckotokensPrice, maalNativeBalance, userNativeBalanceOfChain } from "../Web3/Axioscalls";
import { defaultchainid, idTorpc, multisigwallet, ReservedToken } from "../Web3/Constents";
import { get_Token_Balance_Other, Totak_Supply } from "../Web3/Methods";

export default function Reserves() {
  const {  euroReservedUSDT, reservedinDoller, euroreserved, lockedEuroReserve, totalS } = useContext(AppContext);
  const [totalassets, setTotalAssets] = useState([]);
  const { btcDollarValue, btcValue } = useContext(AppContext);


  // Improved: fetch all reserved assets (native, ERC20, MAAL, EURO, BTC) in one function
  const reserveTokenBalanceforMultiSignWallet = async (address, euroreserved, euroReservedUSDT, btcValue, btcDollarValue, totalS) => {
    try {
      let totalreserved = [];
      let maalValue = 0;
      
      // Fetch both token supplies and EUR price for MAAL utilized calculation
      const icusdSupply = await Totak_Supply("ICUSD");
      const iceurSupply = await Totak_Supply("ICEUR");
      const eurPrice = await coinGeckotokensPrice("euro-coin");
      
      // Calculate MAAL utilized: ICUSD supply + (ICEUR supply * EUR price)
      const maalUtilized = icusdSupply + (iceurSupply * eurPrice);
      
      for (const tokenName in ReservedToken) {
        const tokenData = ReservedToken[tokenName];
        if (tokenData.isNative) {
          const balance = await userNativeBalanceOfChain(address);
          const price = await coinGeckotokensPrice(tokenData.coingeckoid);
          totalreserved.push({
            balance,
            symbol: tokenName,
            value: balance * price,
            utilized: "Not Available"
          });
        } else if (tokenData.tokenName === "MAAL") {
          
          const balance1 = await maalNativeBalance(address);
          const totalbalance = Number(balance1);
          const price = await coinGeckotokensPrice(tokenData.coingeckoid);
          maalValue = totalbalance * price;
          
          // Calculate euroUtilized after maalValue is known
          const euroUtilized = maalUtilized - maalValue;
          
          totalreserved.push({
            balance: totalbalance,
            symbol: tokenName,
            value: maalValue,
            utilized: euroUtilized > 0 ? maalValue : maalUtilized
          });
        } else {
          const balance = await get_Token_Balance_Other(tokenData.address, address, idTorpc[defaultchainid]);
          const price = await coinGeckotokensPrice(tokenData.coingeckoid);
          totalreserved.push({
            balance,
            symbol: tokenName,
            value: balance * price,
            utilized: "Not Available"
          });
        }
      }
      // Add EURO with utilized field
      // EURO utilized = maalUtilized - maalValue (if positive)
      const euroUtilized = maalUtilized - maalValue;
      totalreserved.push({
        balance: euroreserved,
        symbol: "EURO",
        value: euroReservedUSDT,
        utilized: 0
      });
      // totalreserved.push({
      //   balance: euroreserved,
      //   symbol: "EURO",
      //   value: euroReservedUSDT,
      //   utilized: euroUtilized > 0 ? euroUtilized : 0
      // });

      
      // Add BTC if available
      if (btcValue !== null && btcValue !== undefined) {
        // totalreserved.push({
        //   balance: btcValue,
        //   symbol: "BTC",
        //   value: btcDollarValue,
        //   utilized: "Not Available"
        // });
      }
      return totalreserved;
    } catch (error) {
      console.log(error);
      return [];
    }
  };


  useEffect(() => {
    async function fetchAssets() {
      const assets = await reserveTokenBalanceforMultiSignWallet(
        multisigwallet,
        euroreserved,
        euroReservedUSDT,
        btcValue,
        btcDollarValue,
        totalS
      );
      setTotalAssets(assets);
    }
    fetchAssets();
  }, [euroReservedUSDT, btcValue, btcDollarValue, euroreserved, lockedEuroReserve]);


  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      return "Completed";
    } else {
      // Render a countdown
      return <span>{days}D:{hours}H:{minutes}M:{seconds}S</span>;
    }
  };

  return (
    <div className="container m-t-1">
       <TopHeading/>
      <div className="d-g g-t-c g-2 ">
        <div>
          <Data />
        </div>
        <div>
          <Table responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Reserved</th>
                <th>Value (USDT)</th>
                <th>Utilized (USDT)</th>
                <th>Locked Till</th>
              </tr>
            </thead>
            {totalassets.map((res, index) => (
              <tbody key={index}>
                <tr>
                  <td>{res.symbol}</td>
                  <td>{res.balance}</td>
                  <td>{formatNumer(res.value)}</td>
                  <td>
                    {typeof res.utilized === "number"
                      ? formatNumer(res.utilized < 0 ? 0 : res.utilized)
                      : res.utilized === "Not Available"
                        ? "NA"
                        : res.utilized}
                  </td>
                  <td>
                    {/* {res.symbol === "EURO"
                      ? <Countdown date={"2055-03-11 07:07:17"} renderer={renderer} />
                      : "NA"} */}

                    {res.symbol === "EURO"
                      ? "NA"
                      : "NA"}
                      
                  </td>
                </tr>
              </tbody>
            ))}
            <tbody>
              <tr>
                <td><h4>Total</h4></td>
                <td></td>
                <td><h4>{formatNumer(euroReservedUSDT + reservedinDoller + (btcDollarValue || 0))}</h4></td>
              </tr>
            </tbody>
          </Table>
          {/* <button style={{padding:'10px 20px', borderRadius:'10px', border:'none' }}><a href="https://api.gcex.lt/api/v1/account/por/balance" target="_blank" rel="noreferrer">Verify BTC PoR</a></button> */}
          <button style={{padding:'10px 20px', borderRadius:'10px', border:'none', marginLeft:10 }}><a href='https://dons.infinnity.capital' target="_blank" rel="noreferrer">Verify EURO Cash Reserves</a></button>
        </div>
      </div>
      <TableUI />
    </div>
  );
}
